import { useEffect, useState } from "react";
import { Grid } from '@mui/material';
import { useNavigate } from "react-router-dom";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { useStoreStore } from "../../hooks/useStoreStore";
import { TypeProductsModal } from "./components/TypeProductsModal";
import { useTypeProductStore } from "../../hooks/useTypeProductStore";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'code', label: 'Código', align:'center' },
    { type: 'text', field: 'name', label: 'Nombre', align:'center' },
    { type: 'text', field: 'description', label: 'Descripcion', align:'center' },
    { type: 'detail', field: 'detail', label: 'Detalle', align:'center' },
];

export const TypeProductsView = () => {

    const navigate = useNavigate();
    // const { search } = useSelector(selectHeaderState);

    const { setActionTypeProduct, getTypeProducts, deleteTypeProduct } = useTypeProductStore();

    const [loading, setLoading] = useState(false);
    const [branchOffices, setBranchOffices] = useState<any>([]);
    const [rowSelected, setRowSelected] = useState<any>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);

    useEffect(() => {
        getTypeProductsApi()
    },[])

    const getTypeProductsApi = async(search='') => {
        try {
            setLoading(true);
            const response = await getTypeProducts(search);
            if(!response){
                setBranchOffices([]);
                setLoading(false);
                return false;
            }else{
                setBranchOffices(response || []);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onAdd = () => {
        setActionTypeProduct('add');
        setShowModal(true);
    }
    const onEdit = (rowSelected:any) => {
        setActionTypeProduct('edit');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const onDelete = (rowSelected:any) => {
        setActionTypeProduct('delete');
        setRowSelected(rowSelected);
        setShowModalConfirm(true);
    }
    const onDetails = (rowSelected:any) => {
        setActionTypeProduct('detail');
        setRowSelected(rowSelected);
        setShowModal(true);
    }

    const onDeleteConfirm = async() => {
        if (rowSelected) {
            setLoading(true);
            const response = await deleteTypeProduct(rowSelected.id)
            if(response){
                getTypeProductsApi();
                setShowModalConfirm(false);
                setLoading(false);
                setRowSelected('');
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getTypeProductsApi(term)}, 1000)
        )
    }

    const clearState = () => {
        setRowSelected('');
    }

    return (
        <>
            <Grid item xs={12}>
                <CustomTable 
                    title={'Tipos de productos'}
                    columns={columns} 
                    loading={loading}
                    rows={branchOffices || []}
                    onRowClick={() => {}}
                    hasOptions
                    onAddFn={onAdd}
                    onAddFnName={'Nuevo tipo'}
                    onDetails={onDetails}
                    onDelete={onDelete}
                    onEdit={onEdit}
                    onSearch={onSearch}
                    dense
                />
            </Grid>
            {
                showModal && (
                    <TypeProductsModal
                        open = {showModal}
                        closeModal = {() => {setShowModal(false)}}
                        typeSelected = {rowSelected}
                        listTypes = {getTypeProductsApi}
                        clearState = {clearState}
                    />
                )
            }
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={()=>{ setShowModalConfirm(false); clearState()}}
                        onConfirm={onDeleteConfirm}
                        status={loading}
                    />
                )
            }
        </>
    )
}